import {request} from "../request/request";

const passport = {
  getMy: () => request.read('/passport', null, true),
  getOne: (userId) => request.read(`/passport/${userId}`, null, true),
  putMyOne: (data) => request.update('/passport', data, true),
  putFile: (data) => request.update('/passport/file', data, true),
};

export {passport};